module.exports = __webpack_public_path__ + "img/boxed_meals_2.0bb97cd4.jpg";